import {CanActivateChildFn} from '@angular/router';
import {FreemiumPremiumService} from "shared/fremium-premium/freemium-premium.service";
import {inject} from "@angular/core";

export const isAuthorizedByFreemiumPremiumGuard: CanActivateChildFn = (childRoute, state) => {
    const freemiumPremiumService = inject(FreemiumPremiumService)

    if (freemiumPremiumService.isFreemiumPremiumFeatureEnabled() === false) {
        return true; // If the feature is not enabled, allow access}
    }

    if (freemiumPremiumService.isRouteAuthorized(state.url) === false) {
        freemiumPremiumService.triggerUnauthorizedAccess(state.url);
        return false;
    }

    // On ne gère pas d'autre cas pour l'instant, donc on autorise tout le reste

    return true;

};
